import { Search, Database, Building2, UserCheck, Sparkles, Mail, Phone, ShieldCheck, Globe, Trash2, RefreshCw, FileText, BarChart3, Calendar, Send, Mic, MessageCircle, PenLine, UserPlus, Video as LucideIcon, Linkedin } from 'lucide-react';

interface TaskDisplay {
  label: string;
  icon: LucideIcon;
}

const TASK_TYPE_MAP: Record<string, TaskDisplay> = {
  dbleadsrequest: { label: 'Searching database', icon: Database },
  newleadsapollo: { label: 'Searching Apollo', icon: Search },
  searchdmsinternal: { label: 'Searching for decision makers', icon: UserCheck },
  searchdmsapollo: { label: 'Searching Apollo for DMs', icon: Search },
  scrapewebsite: { label: 'Scraping website', icon: Globe },
  scrapelinkedincp: { label: 'Scraping LinkedIn page', icon: Linkedin },
  scrapelinkedindm: { label: 'Scraping LinkedIn profile', icon: Linkedin },
  qualifycp: { label: 'Qualifying company', icon: ShieldCheck },
  qualifydm: { label: 'Qualifying decision maker', icon: ShieldCheck },
  enrichdmapollo: { label: 'Enriching decision maker', icon: Sparkles },
  enrichdmlusha: { label: 'Enriching contact details', icon: Sparkles },
  enrichemaillusha: { label: 'Validating email', icon: Mail },
  enrichmobilelusha: { label: 'Verifying phone number', icon: Phone },
  cleandmcontacts: { label: 'Cleaning contact details', icon: Trash2 },
  fetchopenjobs: { label: 'Fetching open positions', icon: Building2 },
  generateinsights: { label: 'Generating insights', icon: BarChart3 },

  firstcall: { label: 'Making first call', icon: Phone },
  followupcall: { label: 'Follow-up call', icon: Phone },
  analyzecall: { label: 'Analyzing call', icon: BarChart3 },
  prepsendinfo: { label: 'Preparing info package', icon: FileText },

  firstmessage: { label: 'Sending first message', icon: Send },
  followupmessageactive: { label: 'Sending follow-up', icon: Send },
  followupmessageinactive: { label: 'Re-engaging lead', icon: Send },
  wa_generate_reply: { label: 'Crafting reply', icon: PenLine },
  wa_send_reply: { label: 'Sending reply', icon: MessageCircle },
  wa_generate_audio_reply: { label: 'Recording voice note', icon: Mic },
  wa_send_audio_reply: { label: 'Sending voice note', icon: Mic },
  wa_convert_audio: { label: 'Processing audio', icon: Mic },
  wa_transcribe_audio: { label: 'Transcribing audio', icon: FileText },
  sendinfowa: { label: 'Sending info via WhatsApp', icon: Send },
  wameetingconfirm: { label: 'Confirming meeting', icon: Calendar },
  wameetingremind24: { label: 'Sending 24h reminder', icon: Calendar },
  wameetingremind30: { label: 'Sending 30min reminder', icon: Calendar },
  wameetingremind4: { label: 'Sending 4h reminder', icon: Calendar },
  wameetingrescheduled: { label: 'Rescheduling meeting', icon: Calendar },

  firstemail: { label: 'Sending first email', icon: Send },
  secondemail: { label: 'Sending second email', icon: Send },
  followupemail: { label: 'Sending follow-up email', icon: Send },
  generateemailreply: { label: 'Crafting email reply', icon: PenLine },
  replytoemail: { label: 'Replying to email', icon: Mail },
  sendinfoemail: { label: 'Sending info email', icon: Send },
  emailmeetingconfirm: { label: 'Confirming meeting', icon: Calendar },
  emailmeetingremind24: { label: 'Sending 24h reminder', icon: Calendar },
  emailmeetingremind30: { label: 'Sending 30min reminder', icon: Calendar },
  emailmeetingremind4: { label: 'Sending 4h reminder', icon: Calendar },
  emailmeetingrescheduled: { label: 'Rescheduling meeting', icon: Calendar },

  lkdin_generate_reply: { label: 'Writing LinkedIn message', icon: PenLine },
  lkdin_send_reply: { label: 'Sending LinkedIn message', icon: Send },
  lkdin_generate_audio_reply: { label: 'Recording voice note', icon: Mic },
  lkdin_send_audio_reply: { label: 'Sending voice note', icon: Mic },
  lkdin_convert_audio: { label: 'Processing audio', icon: Mic },

  analyzeconvo: { label: 'Analyzing conversation', icon: BarChart3 },
  analyzeoverallead: { label: 'Analyzing lead overall', icon: BarChart3 },
  bookmeeting: { label: 'Booking meeting', icon: Calendar },

  connectionrequest: { label: 'Sending connection request', icon: UserPlus },
  lkdin_cr: { label: 'Sending connection request', icon: UserPlus },
};

const FALLBACK: TaskDisplay = { label: 'Processing task', icon: RefreshCw };

export function getTaskDisplay(taskType: string): TaskDisplay {
  return TASK_TYPE_MAP[taskType] || FALLBACK;
}
